// components/journey-surface/journey-legend.js
// ═══════════════════════════════════════════════
// LegendGroup — state-grouped node list for the journey map panel.

import React from 'react';
import { NODE_STATUS } from '../../lib/workspace-config';

// ── Legend group — state-grouped node list ─────────────────
export function LegendGroup({ label, color, rows, nodes, positioned, focusedNodeId, onNodeClick, onDeleteNode, count }) {
  if (!rows || rows.length === 0) return null;
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 0 3px',
        fontSize: 9,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        color: color || '#333',
        fontFamily: 'Georgia, serif',
      }}>
        <span>{label}</span>
        {count && <span style={{ color: '#333' }}>{count}</span>}
        <div style={{ flex: 1, height: 1, background: '#1e1e2a' }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {rows.map(row => {
          const isFocused = row.id === focusedNodeId;
          const node = (nodes || []).find(n => n.id === row.id);
          const isBuilding = node?.status === NODE_STATUS.BUILDING;
          return (
            <div
              key={row.id}
              onClick={() => onNodeClick?.({ id: row.id, ...positioned?.find(p => p.id === row.id) })}
              onMouseEnter={e => { const del = e.currentTarget.querySelector('.node-delete'); if (del) del.style.opacity = 1; }}
              onMouseLeave={e => { const del = e.currentTarget.querySelector('.node-delete'); if (del) del.style.opacity = 0; }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                padding: '5px 7px',
                borderRadius: 6,
                border: `1px solid ${isFocused ? 'rgba(200,169,110,0.25)' : isBuilding ? 'rgba(200,169,110,0.15)' : '#141414'}`,
                background: isFocused ? 'rgba(200,169,110,0.06)' : isBuilding ? 'rgba(200,169,110,0.04)' : 'transparent',
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
            >
              {isBuilding && (
                <div style={{
                  width: 5, height: 5, borderRadius: '50%',
                  background: '#c8a96e', flexShrink: 0,
                  animation: 'wsmap-status-pulse 1.5s infinite',
                }} />
              )}
              <div style={{
                width: 22, height: 22, borderRadius: 5,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 9, flexShrink: 0,
                background: `${row.color}18`,
                color: row.color,
                fontFamily: 'Georgia, serif',
                fontWeight: 700,
              }}>
                {row.label}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontSize: 11,
                  color: isFocused ? '#d4d4d4' : '#a8a8a8',
                  fontFamily: 'Georgia, serif',
                  lineHeight: 1.4,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}>
                  {row.title}
                </div>
                <span style={{
                  fontSize: 8,
                  padding: '1px 5px',
                  borderRadius: 3,
                  border: `1px solid ${row.color}33`,
                  color: `${row.color}99`,
                  fontFamily: 'Georgia, serif',
                }}>
                  {row.type}
                </span>
              </div>
              {/* Delete button — hover reveal */}
              {onDeleteNode && node?.type !== 'root' && (
                <button
                  className="node-delete"
                  onClick={(e) => { e.stopPropagation(); onDeleteNode(row.id); }}
                  title="Remove node"
                  style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: '#333', fontSize: 12, padding: '0 4px',
                    opacity: 0, transition: 'opacity 0.15s, color 0.15s',
                    flexShrink: 0,
                  }}
                  onMouseEnter={e => { e.currentTarget.style.color = '#c46050'; e.currentTarget.style.opacity = 1; }}
                  onMouseLeave={e => { e.currentTarget.style.color = '#333'; e.currentTarget.style.opacity = 0; }}
                >
                  ×
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
